import { HeadProps, PageProps, graphql } from 'gatsby'
import * as React from 'react'
import OfferTemplate from '../components/offers/offerTemplate'
import {
  GoogleForJobsMapper,
  graphqlOfferMapper,
} from '../components/offers/offer/mapper'
import { AppHead } from '../components/common'

const Offer: React.FC<PageProps<Queries.OfferQuery>> = ({ data }) => {
  const mappedData = graphqlOfferMapper(data)
  const constants = {
    siteStrapiUrl: data.site?.siteMetadata?.siteStrapiUrl ?? null,
    frontStrapiToken: data.site?.siteMetadata?.frontStrapiToken ?? null,
    googleMapsApiKey: data.site?.siteMetadata?.googleMaps?.apiKey ?? null,
    recaptchaKey: data.site?.siteMetadata?.recaptchaKey ?? null,
  }

  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'offer details', {
      event_category: 'page offre',
      event_label: `Vu sur offre ${mappedData?.slug}`,
      company_name: mappedData?.office?.firm?.name,
      event_slug: mappedData?.slug,
      event_title: mappedData?.title,
      offer_id: mappedData?.id,
    })
  }

  return (
    <OfferTemplate
      data={mappedData}
      constants={constants}
      isCareerSite={false}
    />
  )
}

export default Offer

export const Head: React.FC<HeadProps<Queries.OfferQuery>> = ({ data }) => {
  const NoIndexingPage =
    data.strapiAccountingOffer?.office?.firm?.name === 'Cabinet Lama & Associés'
  const offerFirmheaderImage =
    data.strapiAccountingOffer?.office?.firm?.header?.url ||
    '/lamacompta-sharing-default.jpg'
  const offerTitle = data.strapiAccountingOffer?.title
  const offerCity = data.strapiAccountingOffer?.office?.city
  const cityText = offerCity ? `à ${offerCity}` : ''
  const offerFirm = data.strapiAccountingOffer?.office?.firm?.name
  const linkCanonical = data.strapiAccountingOffer?.slug
    ? `${data.site?.siteMetadata?.siteUrl}/cabinets/${data.strapiAccountingOffer.office?.firm?.slug}/offres/${data.strapiAccountingOffer?.slug}`
    : null
  const mappedForGoogleData = GoogleForJobsMapper(data)
  return (
    <AppHead
      title={`${offerFirm} recrute un(e) ${offerTitle}`}
      metaDescription={`${offerFirm} recrute un(e) ${offerTitle} ${cityText}`}
      metaTitle={`${data.strapiAccountingOffer?.office?.firm?.name} recrute un(e) ${data.strapiAccountingOffer?.title} ${cityText}`}
      metaImage={offerFirmheaderImage}
      linkCanonical={linkCanonical}
      data={mappedForGoogleData || undefined}
      noIndexing={NoIndexingPage}
    />
  )
}

export const query = graphql`
  query Offer($strapiId: Int) {
    strapiAccountingOffer(strapi_id: { eq: $strapiId }) {
      uuid
      slug
      fullyRemoteJob
      hoursPerWeek
      strapi_id
      ...OfferTools
      ...OfferHeader
      ...OfferEssentialsInfos
      office {
        ...OfferMainMedia
        ...OfferMap
        firm {
          slug
          hasCareerSite
          colorCareerSite
        }
      }
      description {
        ...OfferDescriptions
      }
    }
    site {
      siteMetadata {
        siteUrl
        siteStrapiUrl
        frontStrapiToken
        recaptchaKey
        googleMaps {
          apiKey
        }
      }
    }
  }
`
